/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Popup_Account_LoadingInputs */

const he_extension_popup_account_loading = /** @type {(inputs: Extension_Popup_Account_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טוען…`)
};

const en_extension_popup_account_loading = /** @type {(inputs: Extension_Popup_Account_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading…`)
};

/**
* | output |
* | --- |
* | "Loading…" |
*
* @param {Extension_Popup_Account_LoadingInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const extension_popup_account_loading = /** @type {((inputs?: Extension_Popup_Account_LoadingInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Popup_Account_LoadingInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_popup_account_loading(inputs)
	return en_extension_popup_account_loading(inputs)
});